import React from 'react';
import PageHeader from '../components/PageHeader';
import { testimonials } from '../data/mock';
import usePageMeta from '../hooks/usePageMeta';

const Testimonials = () => {
  usePageMeta({
    title: 'Client Testimonials — Real Spanking & OTK Session Stories',
    description: 'Real stories from Seattle-area clients who have received OTK spankings, paddling, and discipline from RealOTK. First-hand accounts of accountability and personal growth in a safe, professional setting.',
    path: '/testimonials',
  });
  return (
    <div>
      <PageHeader
        eyebrow="Client Voices"
        title="Testimonials"
        subtitle="Real stories from real clients. Names shortened for privacy."
        image="https://images.unsplash.com/photo-1587587448924-b5a1db520d29?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHx3b21hbiUyMHJ1bm5pbmclMjBzaG9lc3xlbnwwfHx8fDE3ODMwOTg5Mzl8MA&ixlib=rb-4.1.0&q=85&w=3840"
      />
      <section className="bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 py-20 md:py-28 space-y-16">
          {testimonials.map((t, i) => (
            <article key={`${t.name}-${t.location}`} className="group">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 rounded-full bg-neutral-900 text-white flex items-center justify-center font-serif text-lg flex-shrink-0">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <h3 className="font-serif text-2xl text-neutral-900">{t.name}</h3>
                  <p className="text-neutral-500 text-sm">{t.location}</p>
                </div>
              </div>
              <blockquote className="text-neutral-700 leading-relaxed whitespace-pre-line border-l-2 border-neutral-900 pl-6 italic text-lg">
                {t.text}
              </blockquote>
              {i < testimonials.length - 1 && <div className="mt-16 border-b border-neutral-200" />}
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
